module.exports = __webpack_public_path__ + "img/certificate_2.b0ade567.png";